import React from 'react';
import { TopBar } from './components/sections/TopBar';
import { Navigation } from './components/sections/Navigation';
import { Footer } from './components/sections/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { ServiceAreasPage } from './pages/ServiceAreasPage';
import { ContactPage } from './pages/ContactPage';
import { BlogPage } from './pages/BlogPage';
export function App() {
  // Simple client-side routing based on hash
  const getPage = () => {
    const path = window.location.pathname;
    switch (path) {
      case '/about':
        return <AboutPage data-id="element-0" />;
      case '/services':
        return <ServicesPage data-id="element-1" />;
      case '/service-areas':
        return <ServiceAreasPage data-id="element-2" />;
      case '/contact':
        return <ContactPage data-id="element-3" />;
      case '/blog':
        return <BlogPage data-id="element-4" />;
      default:
        return <HomePage data-id="element-5" />;
    }
  };
  return <div className="min-h-screen w-full bg-white" data-id="element-6">
      <TopBar data-id="element-7" />
      <Navigation data-id="element-8" />
      {getPage()}
      <Footer data-id="element-9" />
    </div>;
}